import { useEffect } from 'react'

import { trackViewDataIndukNasional } from '@/utils/tracker/modules/datainduk'
import { TrackerSection, TrackerSubSection } from '@/utils/tracker/shared'
import { useFetchYayasanStatsByParentWilayah } from '@/apis/useDataIndukYayasan'

import { TitlePage } from '@/modules/DataInduk/components/TitlePage'

import { Container } from '@/components/Container'

import { DATA_INDUK_YAYASAN_ROUTE } from '@/configs/constants'

import { AreaSummaryStatsYayasan } from '../components/AreaSummaryStats/AreaSummaryStatsYayasan'
import { DataIndukSearchBox } from '../components/DataIndukSearchBox'
import { ListProvinceContainer } from '../components/ProvinceLogoCard/ListProvinceContainer'
import { YayasanDefinitionCollapse } from '../components/YayasanDefinitionCollapse'
import { VARIANT } from '../constant'
import { sumTotalStatsYayasan } from '../helpers'
import { useFilterState } from '../hooks/useFilterState'
import {
  KODE_WILAYAH_NASIONAL,
  KODE_WILAYAH_NASIONAL_FOR_TRACKER,
} from '../provinces'

export const YayasanNasional = () => {
  const { getFilterSearchParamsFromQuery } = useFilterState({
    variant: VARIANT.YAYASAN,
    view: 'list',
  })

  const { data: dataStatsByParent, isPending: isPendingStatsByParent } =
    useFetchYayasanStatsByParentWilayah(KODE_WILAYAH_NASIONAL, {
      enabled: true,
    })

  useEffect(() => {
    trackViewDataIndukNasional({
      section: TrackerSection.YAYASAN,
      subSection: TrackerSubSection.PAUD_DIKDASMEN,
    })
  }, [])

  return (
    <div>
      <section className="flex flex-col" id="search-section">
        <DataIndukSearchBox
          source={DATA_INDUK_YAYASAN_ROUTE}
          locationId={`${KODE_WILAYAH_NASIONAL_FOR_TRACKER}`}
          locationLevel="Nasional"
          placeholder="Cari Data Yayasan"
          variant="yayasan"
        />
      </section>
      <YayasanDefinitionCollapse />

      <section id="title-section" className="bg-white pt-4">
        <Container>
          <AreaSummaryStatsYayasan
            withImage={false}
            image=""
            isPending={isPendingStatsByParent}
            total={
              !isPendingStatsByParent && dataStatsByParent
                ? sumTotalStatsYayasan(dataStatsByParent?.data)
                : 0
            }
            wrapperClass="mb-4"
          />
          <TitlePage variant={VARIANT.YAYASAN} />
        </Container>
      </section>

      <ListProvinceContainer
        provinceId=""
        isPending={isPendingStatsByParent}
        data={dataStatsByParent}
        additionalParams={getFilterSearchParamsFromQuery()}
        prefixPath={DATA_INDUK_YAYASAN_ROUTE}
        variant={VARIANT.YAYASAN}
      />
    </div>
  )
}
